import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import { Box, Card } from '@mui/material'

import api from '../../service/api'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'
import { getCountString, Icons } from '../../utils/utilities'


const AuditQuestionBanks = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"

    const [error, setError] = useState( false )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const department = selectedDepartment !== "all" ? selectedDepartment : ""
            const institute = selectedInstitute !== "all" ? selectedInstitute : ""
            const { data: { data: counts } } = await api.audit.getQuestionBanksCounts( { last30dayscount: true, institute, department } )
            setCounts( counts )
            setError( null )
        } catch ( err ) {
            setError( { code: err?.response?.status, message: err?.response?.data?.message || "Something went wrong while fetching the question banks audit data." } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute, selectedDepartment] )


    useEffect( () => {
        getData()
    }, [getData] )

    return (
        <Box padding="20px" display="flex" flexDirection="column" gap="20px" overflow="auto" flexGrow={1}>

            {/* Header */}
            <AuditPageHeader
                loading={loading}
                title="Question banks audit"
                subtitle="View all question banks activities here."
                countCards={[
                    {
                        icon: Icons.default.QuestionMark,
                        label: "Question Banks",
                        value: getCountString( counts.totalQuestionBanks ),
                        secondary: getCountString( counts.last30daysCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.Group,
                        label: "Questions",
                        value: getCountString( counts.totalQuestions ),
                        secondary: getCountString( counts.last30daysQuestionsCount ),
                        secondaryLabel: "In last 30 days"
                    },
                ]}
            />

            {/* Retry */}
            {error && <Card sx={{ padding: "20px", flexShrink: 0 }}>
                <TryAgainMessageBlock getData={getData} err={error.message} code={error.code} loading={loading} />
            </Card>}
            <Outlet />
        </Box >
    )
}

export default AuditQuestionBanks
